// extracted by mini-css-extract-plugin
export default {"editable-avatar":"editable-avatar__2biLA","edit-mask":"edit-mask__2uI6Y","loading":"loading__1S7kY","hidden-input":"hidden-input__2SOWa","upload-label":"upload-label__25tVx"};